// hooks/useCreateNewReservation.ts
import { useDispatch, useSelector } from 'react-redux';
// import {
//   setLoader
// } from "../slice/bookingCreation/bookingCreationSlice";
import { apartmentBookingApiSlice } from '../api/apartment/apartmentApiSlice';
import { RootState, store } from '../store/store';
import Logger from '../common/logger';
import { setSelectedApartmentDetails, setSelectedEditApartmentDetails } from '../store/slices/bookingCreationSlice';


const fetchApartmentDetailsCall = async (
    apartmentId: string,
) => {
    const data = await store.dispatch(
        apartmentBookingApiSlice.endpoints.getApartmentDetails.initiate({
            apartmentId: apartmentId,
        }),
    );
    return data;
};


export const useFetchApartmentDetails = (isEdit?: boolean) => {
    const dispatch = useDispatch();
    const selectedApartment = useSelector((state: RootState) =>
        isEdit ? state.bookingCreation.selectedEditApartment : state.bookingCreation.selectedApartment,
    );

    const fetchApartments = async () => {
        try {
            //   dispatch(setLoader(true));
            let apartmentDetails;

            const data = await fetchApartmentDetailsCall(
                selectedApartment?.assetId!, // Todo: refactor to not use !
            );

            if (data) {
                apartmentDetails = data.data;
            }
            if (apartmentDetails) {
                dispatch(
                    isEdit
                        ?
                        setSelectedEditApartmentDetails(apartmentDetails)
                        :
                        setSelectedApartmentDetails(apartmentDetails),
                );
            }
            return apartmentDetails;
        } catch (error) {
            Logger('fetchApartmentDetails').error(error);
        }
    };

    return fetchApartments;
};
